var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeezer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7H16.5403V9.02419H20V7Z",
    fill: "#40AB5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.80646H16.5403V11.8307H20V9.80646Z",
    fill: "url(#paint0_linear_291:284)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.6129H16.5403V14.6371H20V12.6129Z",
    fill: "url(#paint1_linear_291:284)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45968 15.4194H4V17.4436H7.45968V15.4194Z",
    fill: "url(#paint2_linear_291:284)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6371 15.4194H8.17742V17.4436H11.6371V15.4194Z",
    fill: "url(#paint3_linear_291:284)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8226 15.4194H12.3629V17.4436H15.8226V15.4194Z",
    fill: "url(#paint4_linear_291:284)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.4194H16.5403V17.4436H20V15.4194Z",
    fill: "url(#paint5_linear_291:284)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8226 12.6129H12.3629V14.6371H15.8226V12.6129Z",
    fill: "url(#paint6_linear_291:284)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6371 12.6129H8.17742V14.6371H11.6371V12.6129Z",
    fill: "url(#paint7_linear_291:284)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6371 9.80646H8.17742V11.8307H11.6371V9.80646Z",
    fill: "url(#paint8_linear_291:284)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_291:284",
    x1: 18.2871,
    y1: 11.8481,
    x2: 18.2546,
    y2: 9.77674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5256,
    stopColor: "#33A65E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_291:284",
    x1: 16.4895,
    y1: 14.5332,
    x2: 20.0524,
    y2: 12.7177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_291:284",
    x1: 4.00063,
    y1: 16.4323,
    x2: 7.45742,
    y2: 16.4323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_291:284",
    x1: 8.18127,
    y1: 16.4323,
    x2: 11.6381,
    y2: 16.4323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_291:284",
    x1: 12.3619,
    y1: 16.4323,
    x2: 15.8187,
    y2: 16.4323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_291:284",
    x1: 16.5385,
    y1: 16.4323,
    x2: 19.9952,
    y2: 16.4323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3559A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_291:284",
    x1: 12.2255,
    y1: 14.1708,
    x2: 15.9551,
    y2: 13.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_291:284",
    x1: 8.05823,
    y1: 12.9516,
    x2: 11.7611,
    y2: 14.2993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CE1938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_291:284",
    x1: 8.47182,
    y1: 9.49188,
    x2: 11.3475,
    y2: 12.1455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5A22"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezer);
export default __webpack_public_path__ + "static/media/deezer.9d4584bae117a4b17228e583d32c8be4.svg";
export { ForwardRef as ReactComponent };